import { render, staticRenderFns } from "./LineNotification.vue?vue&type=template&id=164be892&"
import script from "./LineNotification.vue?vue&type=script&lang=js&"
export * from "./LineNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports